import { render, staticRenderFns } from "./footer-item.vue?vue&type=template&id=4b90a25d"
import script from "./footer-item.vue?vue&type=script&lang=js"
export * from "./footer-item.vue?vue&type=script&lang=js"
import style0 from "./footer-item.vue?vue&type=style&index=0&id=4b90a25d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports